/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { AbstractCommand } from '../AbstractCommand';
import { ModelUtils } from '../util/ModelUtils';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { MarshallCompat } from '../../compat/MarshallCompat';

/**
 * A command used to delete a security scheme.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export abstract class DeleteSecuritySchemeCommand extends AbstractCommand {
    public _schemeName : string;

    public _oldScheme : any;

    public constructor(schemeName? : any) {
        if(((typeof schemeName === 'string') || schemeName === null)) {
            let __args = arguments;
            super();
            if(this._schemeName===undefined) this._schemeName = null;
            if(this._oldScheme===undefined) this._oldScheme = null;
            if(this._schemeName===undefined) this._schemeName = null;
            if(this._oldScheme===undefined) this._oldScheme = null;
            (() => {
                this._schemeName = schemeName;
            })();
        } else if(schemeName === undefined) {
            let __args = arguments;
            super();
            if(this._schemeName===undefined) this._schemeName = null;
            if(this._oldScheme===undefined) this._oldScheme = null;
            if(this._schemeName===undefined) this._schemeName = null;
            if(this._oldScheme===undefined) this._oldScheme = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[DeleteSecuritySchemeCommand] Executing.");
        this._oldScheme = null;
        this._oldScheme = this.doDeleteScheme(document);
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[DeleteSecuritySchemeCommand] Reverting.");
        if(ModelUtils.isDefined(this._oldScheme)) {
            this.doRestoreScheme(document, this._oldScheme);
        }
    }

    /**
     * Deletes the scheme.
     * @param {Document} document
     * @return {*}
     */
    abstract doDeleteScheme(document : Document) : any;

    /**
     * Restores the previously deleted scheme.
     * @param {Document} document
     * @param {*} oldScheme
     */
    abstract doRestoreScheme(document : Document, oldScheme : any);
}
DeleteSecuritySchemeCommand["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteSecuritySchemeCommand";
DeleteSecuritySchemeCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




